import React, { Component } from "react";
import { Query } from "react-apollo";
import { Col, Card, Icon } from "antd";
import GetCertificates from "../../GraphQL/Query/GetCertificates";
import ButtonAction from "./ButtonAction";
import moment from "moment";

const { Meta } = Card;
let types = ["fiel", "sello"];

class Certificates extends Component {
  render() {
    return (
      <Col span={24}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly"
          }}
        >
          {types.map(type => (
            <div key={type} style={{ marginBottom: "2rem", marginTop: "2rem" }}>
              <Query
                query={GetCertificates}
                variables={{ type }}
                fetchPolicy="cache-and-network"
              >
                {({ loading, error, data, refetch }) => {
                  if (loading && !data.getCertificates) return "Loading...";
                  if (error) return <p>Error :(</p>;
                  const {
                    getCertificates: { items: certificates = [] }
                  } = data;
                  if (!certificates.length) return null;
                  return (
                    certificates &&
                    certificates.map(certificate => {
                      const {
                        serial,
                        rfc,
                        type,
                        endDate,
                        cerFile,
                        keyFile
                      } = certificate;
                      return (
                        <Card
                          key={serial}
                          style={{ width: "100%", margin: "2rem 0" }}
                          title={
                            <span style={{ color: "#595959" }}>
                              {type.toUpperCase()}
                            </span>
                          }
                          actions={[
                            <ButtonAction
                              type="download"
                              label=".cer"
                              file={cerFile}
                            />,
                            <ButtonAction
                              type="download"
                              label=".key"
                              file={keyFile}
                            />
                            // <ButtonAction
                            //   type="delete"
                            //   serial={serial}
                            //   keyFile={keyFile}
                            //   cerFile={cerFile}
                            //   refetch={() => refetch()}
                            // />
                          ]}
                        >
                          <Meta
                            avatar={<Icon type="file" />}
                            title={
                              <span
                                style={{ color: "#595959" }}
                              >{`Serial: ${serial}`}</span>
                            }
                            description={
                              <ul>
                                <li>{`RFC: ${rfc}`}</li>
                                <li>{`Vencimiento: ${moment(endDate).format(
                                  "dddd, D MMMM YYYY"
                                )}`}</li>
                              </ul>
                            }
                          />
                        </Card>
                      );
                    })
                  );
                }}
              </Query>
            </div>
          ))}
        </div>
      </Col>
    );
  }
}

export default Certificates;



// WEBPACK FOOTER //
// ./src/Components/Profile/Certificates.js